import { DrinkingDays } from "../types";
import { initialDrinkingDay } from "@dcc/types/drinkingDay";

export const setWeeklyDrinkingDaysReducer = (
  state: DrinkingDays,
  days: number[]
): DrinkingDays => {
  return days.reduce((agg: DrinkingDays, curr: number): DrinkingDays => {
    if (state[curr]) {
      agg[curr] = {
        ...state[curr]
      };
    } else {
      agg[curr] = initialDrinkingDay;
    }
    return agg;
  }, {});
};
